const shuffleQuestions = arr => arr.sort(() => (Math.random() < 0.5 ? 1 : -1));

export default shuffleQuestions;
